import { render, staticRenderFns } from "./gridCol.vue?vue&type=template&id=473c4fd7"
import script from "./gridCol.vue?vue&type=script&lang=js"
export * from "./gridCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports